import { Controller } from "@hotwired/stimulus";
import flatpickr from "flatpickr";

// Connects to data-controller="flatpickr"
export default class extends Controller {
  static values = {
    options: Object,
  };

  connect() {
    this.flatpickr = flatpickr(this.element, {
      ...this.defaultOptions,
      ...this.optionsValue,
    });
  }

  disconnect() {
    this.flatpickr.destroy();
  }

  get defaultOptions() {
    return {};
  }

  // parseOptions(options) {
  //   // Loop through the options, and if there is an "appendTo" key,
  //   // replace the value with querySelector
  //   const parsedOptions = {};
  //   Object.entries(options).forEach(([key, value]) => {
  //     if (key === "appendTo" || key == "positionElement") {
  //       parsedOptions[key] = document.querySelector(value);
  //     } else {
  //       parsedOptions[key] = value;
  //     }
  //   });
  //   return parsedOptions;
  // }
}
